
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class StainedGlassEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 3 * scale;

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    ctx.save();
                    ctx.globalAlpha *= 0.2 / (layerIndex + 1);
                    ctx.fillStyle = pc.color;
                    
                    // Triangular glass fragments
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + spacing, y);
                    ctx.lineTo(x + spacing/2, y + spacing);
                    ctx.closePath();
                    ctx.fill();
                    ctx.stroke();
                    
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    ctx.lineTo(x - spacing/2, y + spacing);
                    ctx.lineTo(x + spacing/2, y + spacing);
                    ctx.closePath();
                    ctx.stroke();
                    ctx.restore();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
